import React from 'react'

import { useDebugFlags } from '#hooks/flags'
import { useMst } from '#state'

/**
 * Temporary shim that mirrors wouter-backed state into MST
 *
 * New React code should read debug flags through `useDebugFlag`, but existing
 * MST consumers still expect `view.isDebugEnabled()` to stay current
 */
export function DebugStateBridge() {
  const debugFlags = useDebugFlags()
  const { view } = useMst()

  // If this seems to lag, we may need to switch this to useLayoutEffect
  React.useEffect(() => {
    view.setDebugFlags([...debugFlags])
  }, [debugFlags, view])

  return null
}
